<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="resCode"
    >

      <template v-slot:image="{ row }">
        <b-img
          rounded
          alt="Rounded image"
          width="80px"
          :src="$osscdn(row.deThumbImageCode) || '/image/static/img/nopic.jpg'"
        ></b-img>
      </template>

      <template v-slot:status="{row}">
        <el-tag
          size="mini"
          :type="row.resStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.resStatusName }}
        </el-tag>
      </template>

      <template v-slot:modiinfo="{ row }">
        Name：{{ row.modifyByName }} <br/> Date：{{ row.modifyDate }}
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="fromLoad('detail', row.resCode)"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="fromLoad('edit', row.resCode)"
              v-if="allow('M')"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del([row.resCode])"
              v-show="row.resStatus === 'Y'"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from "@/mixins/table-auto-height";

export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      allChecked: false,
      indeterminate: false,
      selected: [],
      categoryCodeArray: [],
      dialogVisible2: false, // 选择分类弹窗

      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => {
            this.$emit("submit");
          },
        },
        zoom: true,
        custom: true,
      },
      tableColumn:[
        {
          field: "seq",
          width: 50,
          fixed: "left",
          align: "center",
          type: "seq",
        },
        {
          field: "col-opt",
          title: this.$l("INDEX.table_label_operation") || "操作",
          headerAlign: "center",
          align: "center",
          fixed: "right",
          width: 110,
          slots: {
            default: "opt",
          },
        },
        {
          field: "resNo",
          width: 150,
          title: this.$l("table_label_research_no") || "产品编号",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "resImageUrl",
          width: 120,
          title: this.$l("table_label_image") || "图片",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "center",
          slots: {
            default: "image",
          },
        },
        {
          field: "resName",
          minWidth: 150,
          title: this.$l("table_label_name") || "产品名称",
          headerAlign: "center",
          showHeaderOverflow: "title",
          align: "left",
        },
        {
          field: "resNameEn",
          minWidth: 150,
          title: this.$l("table_label_name_en") || "英文名称",
          headerAlign: "center",
          showHeaderOverflow: "title",
          align: "left",
        },
        {
          field: "resStatus",
          width: 80,
          title: this.$l("table_label_status") || "有效状态",
          align: "center",
          slots: { default: "status" },
        },
        {
          field: "modifyInfo",
          minWidth: 200,
          align: "center",
          title: this.$l("table_label_modifyInfo") || "修改信息",
          slots: { default: "modiinfo" },
        },
      ],
    };
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = "") {
      let params = {
        pageType: ref,
        resCode: val,
      };
      if (ref === "add") {
        // this.dialogVisible2 = true;
        this.dialogCategoryStart();
        return;
      }
      // 跳转页面
      this.$router.push({
        name: "resourceManagement-researchInfoUpdate",
        params: params,
      });
    },
    dialogCategoryStart() {
      let param = {
        pageType: "add",
        resCode: "x",
        // resCode: masterCategoryCode + "=" + masterCategoryCode
      };
      this.$router.push({
        name: "resourceManagement-researchInfoUpdate",
        params: param,
      });
      this.categoryCodeArray = [];
    },
    delRows() {
      let selection = this.selected;
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message:
            this.$l("INDEX.tips_question_del_rows") || "请选择需要删除的数据",
          type: "warning",
        });
        return;
      }
      let tempArray = [];
      selection.forEach((item) => {
        tempArray.push(item.resCode);
      });
      this.del(tempArray);
    },
    del(resCodeList) {
      this.$confirm(
        this.$l("INDEX.tips_question_delete") || "是否删除？",
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api.delResearchInfoApi({ resCodeList }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
            type: "success",
          });
          this.$emit("submit");
        });
      });
    },
  },
};
</script>
